(() => {
  const bindSlideInert = (swiper) => {
    if (!swiper || typeof swiper.on !== 'function') return;

    const sync = () => {
      if (!swiper.slides) return;
      Array.from(swiper.slides).forEach((slide) => {
        const visible =
          typeof slide.isVisible === 'boolean'
            ? slide.isVisible
            : slide.classList.contains('swiper-slide-visible');
        if (visible) {
          slide.removeAttribute('inert');
        } else {
          slide.setAttribute('inert', '');
        }
      });
    };

    swiper.on('init', sync);
    swiper.on('afterInit', sync);
    swiper.on('slideChange', sync);
    swiper.on('transitionEnd', sync);
    swiper.on('resize', sync);
    swiper.on('breakpoint', sync);
    swiper.on('slidesUpdated', sync);
    sync();
  };

  if (typeof window.customElements.get('products-with-media') !== 'undefined') {
    return;
  }

  window.customElements.define(
    'products-with-media',
    class ProductsWithMedia extends HTMLElement {
      constructor() {
        super();

        this.carousel = this.querySelector('[data-products-with-media-carousel]');
        this.swiper = null;
        this.resizeHandler = null;

        this.initProductsWithMedia();
      }

      initProductsWithMedia() {
        try {
          this.setupSwiper();
          this.setupResizeListener();
        } catch (error) {
          console.error('There was a problem with the ProductsWithMedia component:', error);
        }
      }

      setupResizeListener() {
        let resizeTimeout;
        this.resizeHandler = () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            this.handleResize();
          }, 250);
        };

        window.addEventListener('resize', this.resizeHandler);
      }

      handleResize() {
        const isMobile = window.innerWidth <= 749;

        if (isMobile && !this.swiper) {
          this.setupSwiper();
        } else if (!isMobile && this.swiper) {
          this.destroySwiper();
        }
      }

      destroySwiper() {
        if (this.swiper) {
          Array.from(this.swiper.slides || []).forEach((slide) => slide.removeAttribute('inert'));
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }

      setupSwiper() {
        if (!this.carousel) {
          return;
        }

        if (this.carousel.dataset.productsWithMediaCarousel == 'false') {
          return;
        }

        if (window.innerWidth > 749) {
          return;
        }

        if (this.swiper) {
          return;
        }

        this.swiper = new Swiper(this.carousel, {
          slidesPerView: 'auto',
          spaceBetween: 10,
          centeredSlides: false,
          loop: false,
          rewind: true,
          watchSlidesProgress: true,
          a11y: { enabled: true },
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
        });

        bindSlideInert(this.swiper);

        return this.swiper;
      }

      disconnectedCallback() {
        if (this.resizeHandler) {
          window.removeEventListener('resize', this.resizeHandler);
        }
        this.destroySwiper();
      }
    }
  );
})();
